const env = window.getparam('env') || 'prod';
const isPlatform = window.getparam('platform') === 'true' ? true : false;
const appUrl = `https://content.webapi-services.net/web_assets/scripts/experts-analysis/static/js/main.js?env=${env}`;

const handleLang = (lang) => {
    switch (lang) {
        case 'en':
            return 'en-in';
        case 'ar': 
            return 'ar';
        default:
            return 'en-in'
    }
}


const script = document.createElement('script');
script.src = appUrl;
script.async = true;
script.defer = true;
script.onload = function(){
    let langCode = document.body.dataset.languageCode;
    langCode = window.getparam('lang') || handleLang(langCode);
    const app = document.getElementById('expert-app-container');

    window.ExpertsAnalysis.startExpertsApp(app, langCode , isPlatform);
    app.classList.remove('loading');
}
document.body.appendChild(script);

